import React, { useEffect, useState } from "react";
import { getTeams } from "../services/TeamService";

function Standings() {
    const [teams, setTeams] = useState([]);

    useEffect(() => {
        const fetchTeams = () => {
            getTeams().then((data) => {
                if (data && data.teams) {
                    const sorted = data.teams
                        .sort((a, b) => b.wonMatchesCount - a.wonMatchesCount);
                    setTeams(sorted);
                }
            }).catch((err) => console.log("Teams error:", err));
        };
        fetchTeams();
        const interval = setInterval(fetchTeams, 30000);
        return () => clearInterval(interval);
    }, []);

    const getPoints = (team) => (team.wonMatchesCount * 2) + team.drawMatchesCount;
    const getPlayed = (team) => team.wonMatchesCount + team.lostMatchesCount + team.drawMatchesCount;

    return (
        <div id="section-standings" className="spanel active">
            <div className="main-wrap main-wrap-padded">
                <div className="sh">AI IPL League Table · Season 2026</div>
                <div className="stfull">
                    <table>
                        <thead>
                        <tr>
                            <th className="st-th-left">#</th>
                            <th>Team</th>
                            <th>P</th>
                            <th>W</th>
                            <th>L</th>
                            <th>D</th>
                            <th>Pts</th>
                        </tr>
                        </thead>
                        <tbody>
                        {teams.map((team, index) => {
                            const isLeader = index === 0;
                            const pts = getPoints(team);
                            const played = getPlayed(team);
                            return (
                                <tr key={team.teamId} className={isLeader ? "ldr" : ""}>
                                    <td className={`st-rank ${isLeader ? "st-rank-top" : ""}`}>{index + 1}</td>
                                    <td>
                                        <div className="st-team-cell">
                                            {team.teamPictureURL ? (
                                                <img src={team.teamPictureURL} alt={team.name}
                                                     className="st-team-img"
                                                     onError={(e) => { e.target.style.display = 'none'; }} />
                                            ) : <div className="st-team-emoji">🏏</div>}
                                            <div>
                                                <div className="st-team-name">{team.name}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{played}</td>
                                    <td className="st-wins">{team.wonMatchesCount}</td>
                                    <td className={team.lostMatchesCount > team.wonMatchesCount ? "st-loss-bad" : ""}>{team.lostMatchesCount}</td>
                                    <td>{team.drawMatchesCount}</td>
                                    <td className={`st-pts ${isLeader ? "st-pts-top" : ""}`}>{pts}</td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Standings;